module.exports = __webpack_public_path__ + "img/oee1.e8a25f53.svg";